module.exports = __webpack_public_path__ + "img/scatter.bb903bdd.png";